import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import PCLogo from "../icons/Header-Logo.svg";

const Nav = () => {
  return (
    <StyledNav to="/">
      <Logo><img src={PCLogo} alt="Pet connect logo" title="Home" /></Logo>
      <ul>
        <Link to="/about" title="About">About</Link>
        <Link to="/team" title="Team">Team</Link>
      </ul>
    </StyledNav>
  );
};

const StyledNav = styled(Link)`
  min-height: 14vh;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0rem 13rem;
  background-color: #ffffff;
  color: #35495B;

  a {
    font-size: 1.1rem;
    font-weight: bold;
    padding: 0rem 1rem;
    margin: 0rem 1rem;
    border-radius: 30px;
    transition: all 0.5s ease;
    color: #375C5A;
    &:hover {
      color: #35495B;
      text-decoration: none;
      text-decoration: underline .16rem;
    }
  }
`;

const Logo = styled.div`
display: flex;
`;

export default Nav;
